import React from "react";
import SingleExpartContent from "../../../components/SingleExpartContent/SingleExpartContent";
import ParticleBackground from "../../../components/ParticleBackground/ParticleBackground";

const HomeTwoExpertArea = () => {
  return (
    <>
      <section
        id="about"
        className="expart__area pt-115 pb-90 wow fadeInUp"
        data-wow-delay=".4s"
        style={{ position: 'relative', overflow: 'hidden' }}
      >
        <ParticleBackground id="about-particles" variant="mixed" />
        <div className="container">
          <div className="row">
            <div className="col-xl-8 offset-xl-2">
              <div className="section__title section__title-3 text-center mb-45">
                <span>Who We Are</span>
                <h2>About Vector Tech Solutions</h2>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-10 offset-xl-1">
              <div className="text-center">
                <p className="mb-25">
                  Vector Tech Solutions (VectorTechSol) is a U.S.–based technology and telecom services company specializing in customer acquisition, inbound/outbound call center solutions, and digital growth for ISPs, TV providers, and SMB clients.
                </p>
                <p className="mb-25">
                  We combine modern automation, trained sales teams, and quality-driven workflows to deliver high-volume, clean, and compliant orders for our partners.
                </p>
                <div className="mt-30">
                  <h4 className="mb-15 blue-2-color">Our Mission</h4>
                  <p style={{ fontSize: '17px', fontWeight: '500' }}>
                    Help carriers and businesses scale faster, smarter, and without operational friction.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default HomeTwoExpertArea;
